<template>
    <b-modal id="modal-riwayat-kas-kecil" size="md" hide-footer header-class="border-bottom-0 pb-0" body-class="pt-0">
        <template #modal-header="{ close }">
            <div class="d-flex justify-content-between align-items-center w-100">
                <h5 class="m-0 d-flex align-items-center" style="color: #1f4e89; font-weight: 700;">
                    <div style="background-color: #e6f0fa; color: #1976d2; width: 40px; height: 40px; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin-right: 12px;">
                        <i class="fa fa-list-alt"></i>
                    </div>
                    Riwayat Kas Kecil
                </h5>
                <button type="button" class="close" @click="close()" style="color: #1976d2; opacity: 1; font-size: 24px;">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </template>

        <div class="riwayat-kas-kecil-list">
            <div class="timeline-item" v-for="(item, index) in items" :key="index">
                <div class="timeline-icon-wrapper" :class="`icon-${item.color}`"><i class="fa" :class="item.icon"></i></div>
                <div class="timeline-content">
                    <div class="timeline-title" :class="`text-${item.color}`">{{ item.title }}</div>
                    <div class="timeline-separator">:</div>
                    <div class="timeline-user">{{ item.by }}</div>
                    <div class="timeline-date">{{ item.at }}</div>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end border-top pt-3 mt-3">
            <b-button variant="primary" @click="$bvModal.hide('modal-riwayat-kas-kecil')">Tutup</b-button>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: "modal-kas-kecil-riwayat",
    props: {
        items: { type: Array, default: () => [] },
    },
}
</script>

<style scoped>
.riwayat-kas-kecil-list {
    display: flex;
    flex-direction: column;
    margin-top: 24px;
}

.timeline-item {
    display: flex;
    position: relative;
    padding-bottom: 30px;
}

.timeline-item:last-child {
    padding-bottom: 10px;
}

.timeline-item::before {
    content: '';
    position: absolute;
    left: 23px;
    top: 48px;
    bottom: 0;
    width: 2px;
    background-color: #e9ecef;
    z-index: 0;
}

.timeline-item:last-child::before {
    display: none;
}

.timeline-icon-wrapper {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    margin-right: 20px;
    flex-shrink: 0;
    z-index: 1;
}

.icon-blue {
    background-color: #e6f0fa;
    color: #1976d2;
}

.icon-green {
    background-color: #e8f5e9;
    color: #2e7d32;
}

.icon-orange {
    background-color: #fff3e0;
    color: #f57c00;
}

.icon-gray {
    background-color: #f5f5f5;
    color: #757575;
}

.icon-yellow {
    background-color: #fff9c4;
    color: #fbc02d;
}

.icon-purple {
    background-color: #f3e5f5;
    color: #7b1fa2;
}

.text-blue {
    color: #1976d2;
}

.text-green {
    color: #2e7d32;
}

.text-orange {
    color: #f57c00;
}

.text-gray {
    color: #757575;
}

.text-yellow {
    color: #fbc02d;
}

.text-purple {
    color: #7b1fa2;
}

.timeline-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 14px;
    justify-content: center;
    gap: 4px;
}

.timeline-title {
    font-weight: 600;
    font-size: 15px;
}

.timeline-separator {
    display: none;
}

.timeline-user {
    color: #444;
}

.timeline-date {
    color: #888;
    font-size: 13px;
}
</style>
